import Order from 'communication/types/order/Order';
import { IndexedArray } from 'utils/arrays/arrayUtils';

export interface OrderDiff {
    prev: Order;
    next: Order;
}

export interface OrderStreamUpdatedEvent {
    added: IndexedArray<Order>;
    removed: IndexedArray<Order>;
    updated: IndexedArray<OrderDiff>;
    /*
     * If true, the orders stream was completely cleared before any additions/removals (i.e. "ClearData" was received)
     */
    cleared: boolean;
    /*
     * If true this completes a refresh (i.e. RefreshDone was received)
     */
    completesRefresh: boolean;
    batchUpdateInProgress: boolean;
    /*
     * The number of orders removed by a multiple orders remove message
     */
    multipleOrdersRemoved: number;
}

export class OrderStreamUpdatedEventBuilder {
    public event: OrderStreamUpdatedEvent = {
        added: [],
        removed: [],
        updated: [],
        completesRefresh: false,
        batchUpdateInProgress: false,
        cleared: false,
        multipleOrdersRemoved: 0,
    };

    public added(order: Order): void {
        this.event.added[order.idx] = order;
    }

    public updated(prev: Order, next: Order): void {
        if (this.event.added[next.idx]) {
            this.added(next);
        } else {
            this.event.updated[next.idx] = {
                prev: this.event.updated[next.idx]?.prev ?? prev,
                next,
            };
        }
    }

    public removed(prev: Order): void {
        this.event.removed[prev.idx] = prev;
    }
}
